import { AccompanyingNoteCollectorReportsOption } from 'components/waste-management/interfaces'
import * as Yup from 'yup'

export const getInitialValues = editItem => ({
  company: editItem
    ? {
        label: editItem.company.name,
        value: editItem.company.id
      }
    : { label: '', value: '' },
  wasteReports: editItem
    ? editItem.linkedReports.map(report => ({
        label: report.name,
        value: report.id,
        weight: report.weight
      }))
    : [],
  delegateId: editItem?.delegate?.id ?? null,
  delegateName: editItem?.delegate?.name ?? '',
  cnp: editItem?.delegate?.cnp ?? '',
  identityCardSeries: editItem?.delegate?.identityCardSeries ?? '',
  identityCardNumber: editItem?.delegate?.identityCardNumber ?? '',
  identityCardIssuer: editItem?.delegate?.identityCardIssuer ?? '',
  vehicleType: editItem?.delegate?.vehicleType ?? '',
  vehicleNumber: editItem?.delegate?.vehicleNumber ?? '',
  wasteCollectionCompanyDeliveryAddress:
    editItem?.wasteCollectionCompanyDeliveryAddress?.address ?? '',
  wasteCollectionCompanyDeliveryAddressId:
    editItem?.wasteCollectionCompanyDeliveryAddressId?.id ?? ''
})

export const getValidationSchema = () =>
  Yup.object({
    company: Yup.object().shape({
      label: Yup.string().required('Acest camp este obligatoriu.'),
      value: Yup.string().required('Acest camp este obligatoriu.')
    }),
    wasteReports: Yup.array().min(1, 'Acest camp este obligatoriu.'),
    delegateName: Yup.string().required('Acest camp este obligatoriu.'),
    wasteCollectionCompanyDeliveryAddress: Yup.string().required('Acest camp este obligatoriu.')
  })

export const getTotals = (items: AccompanyingNoteCollectorReportsOption[]) =>
  items.reduce((acc: number, item: { weight: number }) => acc + item.weight, 0)
